import React,{ Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardBody, CardHeader} from "reactstrap";
import { getLdapId } from "../../../actions/actionLdap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Ldap",path:"/ldap",isActive: false},
    {name: "ViewLdap",path:"/viewldap",isActive: true},
];

class ViewLdap extends Component{
    constructor(props){
        super(props);
        this.state = {
            userId: null
        };
    }

    componentDidMount(){
        this.props.getLdapId(this.props.match.params.id);
    }

    render(){
        const {ldap_config} = this.props;
        return (
            <div className="profile-page">  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                             <strong>View LDAP Configuration</strong>
                                {ldap_config ? <Link className="pull-right" to={{ pathname: `/updateldap/${ldap_config.ldap_id}`}}> 
                                    <Button className = "reset-btn" size="sm" color="primary"> Edit LDAP Configuration </Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                    <div className="profile-table">
                                            {ldap_config?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Ldap Id</h4></td><td>{ldap_config.ldap_id ? ldap_config.ldap_id : "-"}</td></tr>
                                                        <tr><td><h4>Name</h4></td><td>{ldap_config.name ? ldap_config.name : "-"}</td></tr>
                                                        <tr><td><h4>Url</h4></td><td>{ldap_config.url ? ldap_config.url : "-"}</td></tr>  
                                                        <tr><td><h4>Search Base</h4></td><td>{ldap_config.search_base ? ldap_config.search_base : "-"}</td></tr>
                                                        <tr><td><h4>Search Filter</h4></td><td>{ldap_config.search_filter ? ldap_config.search_filter : "-"}</td></tr> 
                                                        <tr><td><h4>Group Membership Filter</h4></td><td>{ldap_config.group_membership_filter ? ldap_config.group_membership_filter : "-"}</td></tr>
                                                        <tr><td><h4>Email attribute</h4></td><td>{ldap_config.email_attribute?ldap_config.email_attribute:"NA"}</td></tr>
                                                        <tr><td><h4>Service Account DN</h4></td><td>{ldap_config.service_account_dn ? ldap_config.service_account_dn : "-"}</td></tr>
                                                        <tr><td><h4>Search Subtree</h4></td><td><img src={ldap_config.search_subtree ? iconYes  : iconNo } alt="iconNo"/></td></tr>
                                                        <tr><td><h4>Auto Create App User</h4></td><td><img src={ldap_config.auto_create_app_user ? iconYes  : iconNo } alt="iconNo"/></td></tr>
                                                        <tr><td><h4>Enabled</h4></td><td><img src={ldap_config.enabled ? iconYes  : iconNo } alt="iconNo"/></td></tr>                
                                                    </tbody>                            
                                                </Table> : " "}  
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewLdap.propTypes = {
    getLdapId: Proptypes.func.isRequired,
    ldap_config: Proptypes.object,
    match: Proptypes.object
};

export default connect(state => 
    ({
        ldap_config: state.ldap_configs.ldap_config || null
    }),
dispatch => 
    ({  
        getLdapId: (data) => dispatch(getLdapId(data)),
    }))(ViewLdap);


// WEBPACK FOOTER //
// ./src/views/Ldap/ViewLdap/ViewLdap.js